import instance from "../axios/axios.config";
const { provision } = instance;

export const getAnalyticsDataApi = async (payload) => {
    try {
        const response = await provision.post(`/analytics/cost-sec-metrics`, payload)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getVulnerabilityDetailsApi = async (payload) => {
    try {
        const response = await provision.post(`/analytics/security-details`, payload)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const downloadFileApi = async (payload) => {
    try {
        const response = await provision.post(`/analytics/download-csv`, payload, {
            responseType: 'blob',
        })
        return response
    } catch (error) {
        console.error(error)
    }
}